import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const TABS = [
    { key: "scorers", label: "Gol", unit: "gol", empty: "Nessun gol segnato in stagione." },
    { key: "mvp", label: "Migliori in campo", unit: "MVP", empty: "Nessun migliore in campo in stagione." },
];

export default function TeamLeaderboards({ teamId }) {
    const [data, setData] = useState(null);
    const [tab, setTab] = useState("scorers");

    useEffect(() => {
        if (!teamId) return undefined;
        let active = true;
        api.get(`/teams/${teamId}/leaderboards`)
            .then(({ data: d }) => { if (active) setData(d); })
            .catch(() => { if (active) setData({ scorers: [], mvp: [] }); });
        return () => { active = false; };
    }, [teamId]);

    if (!data) return null;
    const current = TABS.find((x) => x.key === tab);
    const rows = data[tab] || [];

    return (
        <div className="op-card mt-6 overflow-hidden" data-testid="team-leaderboards">
            <div className="px-5 py-4 border-b border-t22252a bg-t0e1014 flex flex-wrap items-center justify-between gap-3">
                <div>
                    <div className="op-label text-[10px] text-tff7a1a">// CLASSIFICHE SQUADRA · STAGIONE {data.season_label}</div>
                    <div className="text-tffffff op-heading text-lg">Campionato + coppe</div>
                </div>
                <div className="flex gap-1" data-testid="team-leaderboards-tabs">
                    {TABS.map((x) => (
                        <button
                            key={x.key}
                            type="button"
                            onClick={() => setTab(x.key)}
                            data-testid={`team-leaderboards-tab-${x.key}`}
                            className={`op-label text-[11px] px-3 py-1.5 border transition-colors ${tab === x.key ? "border-tff7a1a text-tff7a1a bg-tff7a1a/10" : "border-t22252a text-t8f95a3 hover:text-tffffff"}`}
                        >
                            {x.label}
                        </button>
                    ))}
                </div>
            </div>
            {rows.length === 0 ? (
                <div className="px-5 py-6 text-sm text-t8f95a3" data-testid="team-leaderboards-empty">{current.empty}</div>
            ) : (
                <ul className="divide-y divide-t16181c" data-testid={`team-leaderboards-list-${tab}`}>
                    {rows.map((p) => <LeaderRow key={p.pes_id} p={p} unit={current.unit} />)}
                </ul>
            )}
        </div>
    );
}

function LeaderRow({ p, unit }) {
    return (
        <li className="px-5 py-2.5 flex items-center gap-3" data-testid={`team-leader-row-${p.pes_id}`}>
            <span className="op-mono text-sm w-6 text-t5c6370">{p.rank}</span>
            {p.image_url
                ? <img src={p.image_url} alt="" className="w-8 h-8 object-cover rounded-full bg-t16181c" />
                : <span className="w-8 h-8 rounded-full bg-t16181c" />}
            <div className="flex-1 min-w-0">
                <Link to={`/giocatori/${p.pes_id}`} className="text-sm text-tffffff hover:underline truncate block">{p.name || "—"}</Link>
                <div className="op-mono text-[10px] text-t5c6370">
                    {p.position || ""}{!p.in_roster && " · non più in rosa"}
                </div>
            </div>
            <span className="op-mono text-base font-semibold text-tffffff" data-testid={`team-leader-value-${p.pes_id}`}>
                {p.value} <span className="text-[10px] text-t8f95a3">{unit}</span>
            </span>
        </li>
    );
}
